var $5d32d81e97bfe96a$exports = {};
$5d32d81e97bfe96a$exports = {
    "breadcrumbs": `Putanje navigacije`
};


export {$5d32d81e97bfe96a$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
